export enum ReservationAction {
  PENDING = 'act_pending',
  CANCEL = 'act_cancel',
  CHECK_IN = 'act_check_in'
}